import { connect } from 'react-redux'
import OrdersComponent from '../components'
import { fetchOrders, fetchOrderStatus } from '../actions/ApiRequest'

const mapStateToProps = (state) => ({
  orders: state.orders.list,
  pagination: state.orders.pagination,
  merchantCanonicalName: state.merchant.canonical_name,
})

const mapDispatchToProps = (dispatch) => ({
  fetchOrders: (currentPage, perPage) => dispatch(fetchOrders(currentPage, perPage)),
  fetchOrderStatus: (id) => dispatch(fetchOrderStatus(id)),
})

const Orders = connect(mapStateToProps, mapDispatchToProps)(OrdersComponent)

export default Orders
